import { Collapsible, CollapsiblePanel, CollapsibleTrigger } from '@HoudiniUI/Collapsible';
import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

export const FindingGroup = ({
	label,
	count,
	defaultOpen,
	children,
}: React.PropsWithChildren<{
	label: string;
	count?: string;
	defaultOpen?: boolean;
}>) => {
	const [open, setOpen] = React.useState(!!defaultOpen);
	return (
		<Collapsible open={open} onOpenChange={setOpen} className={css(styleSheet.group)}>
			<CollapsibleTrigger className={css(styleSheet.groupTrigger)}>
				<span className={css(styleSheet.groupChevron)} aria-hidden>
					{open ? '▾' : '▸'}
				</span>
				{label}
				{count ? <span className={css(styleSheet.groupCount)}>{count}</span> : null}
			</CollapsibleTrigger>
			<CollapsiblePanel>
				<div className={css(styleSheet.groupBody)}>{children}</div>
			</CollapsiblePanel>
		</Collapsible>
	);
};
